import { Flex } from "@chakra-ui/react";
import useBottomNavBar from "../../hooks/useBottomNavBar";

/**
 * @typedef {Object} Props
 * @property {React.ReactNode} children
 *
 * @param {Props} props
 */
function StepBottomBar({ children }) {
  const { navBarHeight } = useBottomNavBar();

  return (
    <Flex
      position="sticky"
      bottom={`${navBarHeight}px`}
      justifyContent="flex-end"
      backgroundColor="#fff"
      borderBottomRadius="1rem"
      borderTopWidth="1px"
      py=".5rem"
      px="1rem">
      {children}
    </Flex>
  );
}

export default StepBottomBar;
